var cssCreator = (function () {
	'use strict';

	/**
	 * defaultPMMap[pmName.toLowerCase()] = logoName | {"default":logoName, "[language_1_Iso]": logoName_1, "[language_2_Iso]": logoName_2 ...}
	 */
	var defaultPMMap = {
		alipay                                : 'alipay',                 //??
		apmgw_fast_bank_transfer1             : 'fastbanktransfer',       //?
		ppp_nop_displayinstructions           : 'fastbanktransfer',       //?
		astropaycard                          : 'astropay',               //?
		netswipe                              : 'bamcheckout',
		apmgw_1pay                            : '1pay',
		apmgw_abaqoos                         : 'abaqoos',
		apmgw_abon                            : 'abon',
		apmgw_ach                             : 'bank_transfer_new',
		apmgw_africa_payouts_mobilemoney      : 'local_africa',
		apmgw_africa_payouts_barter           : 'local_africa',
		apmgw_africa_payouts_banktransfer     : 'local_africa',
		apmgw_afterpay                        : 'afterpay',
		apmgw_airbank                         : 'air_bank',
		apmgw_aircash                         : 'aircash',
		apmgw_alipayunified                   : 'alipay_unified',
		apmgw_alipay                          : 'alipay_plus',
		apmgw_alipay_di                       : 'alipay',
		apmgw_alipayhk                        : 'alipayhk',
		apmgw_alfa_click                      : 'alfa_bank',
		apmgw_apmemulator					  : 'apm_test_nuvei',
		apmgw_astropay                        : 'astropay-2',
		apmgw_astropayprepaid                 : 'astropayprepaid',
		apmgw_astropayprepaid_bf              : 'astropayprepaid',
		apmgw_astropay_tef                    : 'astropay-tef',
		apmgw_local_payments                  : 'local_payments',
		apmgw_astropay_visa                   : 'visa',
		apmgw_astropay_mastercard             : 'master_card',
		apmgw_astropaybankpayouts             : 'astropaypayouts',
		apmgw_aupay                           : 'au_pay',
		apmgw_bacs                            : 'bacs',
		apmgw_banco_industrial				  : 'banco_industrial',
		apmgw_bbva_frances                    : 'bbva_frances',
		apmgw_banco_corrientes                : 'banco_corrientes',
		apmgw_banco_galicia                   : 'banco_galicia',
		apmgw_bancolombia                     : 'bancolombia',
		apmgw_bank_handlowy                   : 'citi_handlowy',
		apmgw_bank_transfer                   : 'bank_transfer_new',
		apmgw_bank_transfer_china             : 'bank_transfer_logo',
		apmgw_bank_transfer_japan             : 'bank_transfer_logo',
		apmgw_online_bank_transfer_malaysia   : 'bank_transfer_logo',
		apmgw_bank_transfer_malaysia          : 'bank_transfer_malaysia',
		apmgw_bankpayin                       : 'bank_transfer_new',
		apmgw_bizum                           : 'bizum',
		apmgw_boost                           : 'boost',
		apmgw_br_credit_card                  : 'default_cc_new',
		apmgw_banrisul						  : 'banrisul',
		apmgw_bkash  						  : 'bkash',
		apmgw_santander_rio                   : 'santander_rio',
		apmgw_icbc                            : 'icbc',
		apmgw_caixa                           : 'caixa',
		apmgw_khipu                           : 'khipu',
		apmgw_banco_falabella                 : 'banco_falabella',
		apmgw_banco_credichile                : 'banco_credichile',
		apmgw_banco_bice                      : 'banco_bice',
		apmgw_banco_nacional                  : 'banco_nacional',
		apmgw_banco_security                  : 'banco_security',
		apmgw_banco_azteca                    : 'banco_azteca',
		apmgw_banka_creditas                  : 'banka_creditas',
		apmgw_bank_payouts                    : 'bank_transfer_logo',
		apmgw_swiss_payouts                   : 'bank_transfer_logo',
		apmgw_local_payouts_europe            : 'bank_transfer_logo',
		apmgw_bangkok_bank_atm                : 'bangkok_bank',
		apmgw_bangkok_bank_ipay               : 'bangkok_bank',
		apmgw_bangkok_bank_mobile             : 'bangkok_bank',
		apmgw_bci                             : 'bci',
		apmgw_banco_de_chile                  : 'banco_de_chile',
		apmgw_biiva                           : 'biiva',
		apmgw_bpi                             : 'bpi',
		apmgw_santander_cl                    : 'santander_cl',
		apmgw_banco_estado                    : 'banco_estado',
		apmgw_efecty                          : 'efecty',
		apmgw_baloto                          : 'baloto',
		apmgw_red_servi                       : 'red_servi',
		apmgw_banorte                         : 'banorte',
		apmgw_spei                            : 'spei',
		apmgw_bbva_bancomer                   : 'bbva_bancomer',
		apmgw_banamex                         : 'banamex',
		apmgw_santander_mx                    : 'santander_mx',
		apmgw_page_express                    : 'page_express',
		apmgw_pago_efectivo                   : 'pago_efectivo',
		apmgw_payshop                         : 'payshop',
		apmgw_red_pagos                       : 'red_pagos',
		apmgw_bancosantander                  : 'santander',
		apmgw_bankpayouts                     : 'bank_payouts',
		apmgw_bitpay                          : 'bitpay',
		apmgw_bkm_ekspress                    : 'bkmexpress',
		apmgw_boku                            : 'boku',
		apmgw_boleto                          : 'boleto',
		apmgw_boleto_rapido					  : 'boleto_rapido',
		apmgw_bpay                            : 'bpay',
		apmgw_cash_app                        : 'cash_app',
		apmgw_cash_in                         : 'io_money',
		apmgw_cashoptionthailand              : 'bigc_tesco_lotus',
		apmgw_cashu                           : 'cashu',
		apmgw_cimbclicks                      : 'cimb_clicks',
		apmgw_citadel                         : 'instantcitadel',
		apmgw_citadel_sa                      : 'citadel_sa',
		apmgw_clave                           : 'clave',
		apmgw_clearpay                        : 'clearpay',
		apmgw_clickandbuy                     : 'clickandbuy',
		apmgw_paywithcrypto                   : 'pay_with_crypto',
		apmgw_paywithbanktransfer			  : 'pay_with_bank_transfer',
		apmgw_duitnow						  : 'duitnow',
		apmgw_codi                			  : 'codi',
		apmgw_colombia_payouts                : 'netbanking',
		apmgw_cross_bank_qr                   : 'cross_bank_qr',
		apmgw_cryptogo						  : 'crypto_and_go',
		apmgw_cvspharmacy					  : 'cvs',
		apmgw_dana                            : 'dana',
		apmgw_danamon                         : 'danamon',
		apmgw_daviplata                       : 'daviplata',
		apmgw_davivienda                      : 'davivienda',
		apmgw_dbarai                          : 'd-barai',
		apmgw_digital_wallet                  : 'digital_wallet',
		apmgw_dimonex                         : 'dimonex',
		apmgw_dineromail                      : 'dineromail',
		apmgw_dotpay                          : 'dotpay',
		apmgw_dragonpay                       : 'dragon_pay',
		apmgw_dollargeneral                   : 'dollar_general',
		apmgw_easypaisa                       : 'easypaisa',
		apmgw_ecard                           : 'ecard',
		apmgw_ecopayz                         : 'ecopayz',
		apmgw_enets                           : 'enets',
		apmgw_eft_pro                         : 'ozow',
		apmgw_elementpay_payouts			  : 'netbanking',
		apmgw_elo                             : 'elo',
		apmgw_epay_bg                         : 'epay',
		apmgw_easypay                         : 'easy_pay',
		apmgw_epaylink                        : 'epaylinks',
		apmgw_epin                            : 'epin',
		apmgw_ekonto                          : 'ekonto',
		apmgw_eps                             : 'eps',
		apmgw_equitel                         : 'equitel',
		apmgw_euteller                        : 'euteller',
		apmgw_ewire                           : 'ewire',
		apmgw_ewiredk                         : 'ewire',
		apmgw_ewireno                         : 'ewire',
		paypal                                : 'paypal',
		apmgw_paypal_sdk                      : 'paypal',
		apmgw_pay_later                       : 'paypal',
		apmgw_expresscheckout                 : 'paypal',
		apmgw_exito                           : 'exito',
		apmgw_fawry                           : 'fawry_wallet',
		apmgw_faster_payments                 : 'faster_payments',
		apmgw_finnish_banks                   : 'paytrail',
		apmgw_fortumo                         : 'pay_by_mobile',
		apmgw_fundsend                        : 'fundsend',
		apmgw_elv                             : 'elv',
		apmgw_gcash                           : 'gcash',
		apmgw_giropay                         : 'giropay',
		apmgw_gopay							  : 'gopay',
		apmgw_gopay_id						  : 'gopay_id',
		apmgw_grabpay                         : 'grabpay',
		apmgw_grabpay_malaysia                : 'grabpay',
		apmgw_halcash                         : 'halcash',
		apmgw_hipay                           : 'hipay',
		apmgw_hipercard                       : 'hipercard',
		apmgw_hongleong                       : 'hong_leong_connect',
		apmgw_iban_on_demand                  : 'iban',
		apmgw_ibanq                           : 'ibanq',
		apmgw_ideal                           : 'ideal',
		apmgw_idebit                          : 'idebit',
		apmgw_ids                             : 'instadebit',
		apmgw_india_payouts                   : 'net_banking_new',
		apmgw_ininal                          : 'ininal',
		apmgw_inpay                           : 'inpay',
		apmgw_instadebit                      : 'instadebit',
		apmgw_instant_bank_payments_dk        : 'ibt_dk',
		apmgw_instant_bank_payments_ee        : 'ibt_ee',
		apmgw_instant_bank_payments_fi        : 'ibt_fi',
		apmgw_instant_bank_payments_se        : 'ibt_se',
		apmgw_instant_bank_transfer           : 'instant_bank_transfer',
		apmgw_instantswisspayout              : 'instant_swiss',
		apmgw_intercash_prepaid               : 'intercash',
		apmgw_intercash_bd                    : 'intercash',
		apmgw_intercash_bd_express            : 'intercash',
		apmgw_international_transfers         : 'international_transfers',
		apmgw_ipara                           : 'ipara',
		apmgw_jpbank                          : 'bank_transfer_logo',
		apmgw_jtbanka                         : 'jt_banka',
		apmgw_jpmorgan                        : 'jpmorgan',
		apmgw_kakaopay                        : 'kakao_pay',
		apmgw_kbank_atm                       : 'kbank_2',
		apmgw_kbank_mobile                    : 'kbank_2',
		apmgw_konbini                         : 'konbini',
		apmgw_latam_payouts                   : 'astropaypayouts',
		apmgw_linkaja                         : 'link_aja',
		apmgw_lobanet                         : 'lobanet',
		apmgw_local_currency_payouts          : 'bank_transfer_logo',
		apmgw_moneybookers                    : 'skrill',
		acc                                   : 'skrill',
		wlt                                   : 'skrill',
		moneybookers                          : 'skrill',
		apmgw_lean                            : 'open_banking',
		apmgw_local_payments_africa           : 'local_africa',
		apmgw_local_payments_africa_cards     : 'local_africa',
		apmgw_page                            : 'local_africa',
		apmgw_nqr                             : 'local_africa',
		apmgw_payattitude                     : 'local_africa',
		apmgw_ussd                            : 'local_africa',
		apmgw_line_pay                        : 'line_pay',
		apmgw_local_payments_indonesia        : 'idr_va',
		apmgw_local_payments_vietnam          : 'vn_pay',
		apmgw_local_payouts                   : 'bank_transfer_logo',
		apmgw_loterica                        : 'loterias',
		apmgw_lpay 							  : 'lpay',
		apmgw_mandiri                         : 'bank_mandiri',
		apmgw_mcbyastropay                    : 'mastercard_by_astropay',
		apmgw_mercadopago                     : 'mercado',
		apmgw_merpay                          : 'merpay',
		apmgw_micropayment                    : 'paypal',
		apmgw_mistercash                      : 'mistercash',
		apmgw_mobikwik						  : 'mobikwik',
		apmgw_mobil_odeme                     : 'mobilodeme',
		apmgw_mobilepay                       : 'mobilepay',
		apmgw_molpay                          : 'molpay',
		apmgw_momo_wallet                     : 'momo',
		apmgw_mplatba						  : 'mplatba',
		apmgw_mtcpay                          : 'mtc_pay',
		apmgw_mtn_mobile_money                : 'mtn',
		apmgw_muamalat                        : 'bank_muamalat',
		apmgw_m_pesa                          : 'mopesa',
		apmgw_instanttransfer                 : 'instanttransfer',
		apmgw_fast_bank_transfer              : 'fastbanktransfer',
		apmgw_faster_bank_transfer            : 'fasterbanktransfer',
		//apmgw_citadel                       : 'instantcitadel',
		banktransfer                          : 'fastbanktransfer',
		withdraw_bank_transfer                : 'fastbanktransfer',
		apmgw_moneta                          : 'monetaru',
		apmgw_moneta_direct_integration_      : 'monetaru',
		apmgw_moneta__direct_integration_     : 'monetaru',
		apmgw_mach							  : 'mach',
		apmgw_webmoney                        : 'webmoney',
		apmgw_webmoney_direct_integration_    : 'webmoney',
		apmgw_webmoney_sms_invoice_           : 'webmoney',
		apmgw_western_union_panama			  : 'western_union',
		apmgw_yandexmoney                     : 'yandex_money',
		apmgw_yandex_money                    : 'yandex_money',
		apmgw_yape                    		  : 'yp',
		apmgw_zong_sms_pin                    : 'zong',
		apmgw_multibanco                      : 'multibanco',
		apmgw_naverpay                        : 'naver_pay',
		apmgw_neosurf                         : 'neosurf',
		apmgw_neosurf_direct_integration_     : 'neosurf',
		apmgw_neosurf_uk_direct_integration_  : 'neosurf',
		apmgw_neosurf_ca_direct_integration_  : 'neosurf',
		apmgw_nequi                           : 'nequi',
		apmgw_nequi_co                        : 'nequi',
		apmgw_nestbank						  : 'nest_bank',
		apmgw_netbankingbyastropay            : 'inb_by_astropay',
		apmgw_neteller                        : 'neteller',
		apmgw_netpay_ssl                      : 'netpay',
		apmgw_nibss                           : 'nibss',
		apmgw_nordea                          : 'nordea',
		apmgw_npp                             : 'npp',
		apmgw_okto_cash                       : 'okto_cash',
		apmgw_okto_wallet                     : 'okto_wallet',
		apmgw_onecard                         : 'one_card',
		apmgw_online_banking_thailand         : 'online_banking_thailand',
		apmgw_ovo                             : 'ovo',
		apmgw_octopus                         : 'octopus',
		apmgw_pademobile                      : 'pademobile',
		apmgw_pagocash                        : 'pago_cash',
		apmgw_paguelofacil                    : 'paguelo_facil',
		apmgw_pay_com                         : 'paydotcom',
		apmgw_pay4fun                         : 'pay_for_fun',
		apmgw_pay4me                          : 'pay4me',
		apmgw_paycash                         : 'efectivo',
		apmgw_paybycash                       : 'paybycash',
		apmgw_paybycash_openamount            : 'paybycash',
		apmgw_paybycash_openmultiuse          : 'paybycash',
		apmgw_payco                           : 'payco',
		apmgw_paypay                          : 'paypay',
		apmgw_payretailers_cc                 : 'default_cc_new',
		apmgw_paysera                         : 'pay_sera',
		apmgw_payto                           : 'payto',
		apmgw_poland_instant_payout           : 'bank_transfer_logo',
		apmgw_pay_by_bank_app				  : 'open_banking_v2',
		apmgw_pay_by_bank_app_instant 	   	  : 'open_banking_v2',
		paydotcom                             : 'paydotcom',
		entropay                              : 'entropay',
		nuvei_card							  : 'mvp',
		apmgw_paynearme						  : 'paynearme',
		apmgw_paysafecard                     : 'paysafecard',
		paysafecard                           : 'paysafecard',
		apmgw_payeasy                         : 'pay_easy',
		apmgw_paynow                          : 'paynow',
		apmgw_payu                            : 'payu',
		apmgw_pbsbank                         : 'pbs_bank',
		apmgw_pesalink                        : 'pesalink',
		apmgw_pespay                          : 'efectivo', // 'pespay',
		apmgw_plusbank                        : 'plus_bank',
		apmgw_pluspay                         : 'pluspay',
		apmgw_playplus                        : 'playplus',
		apmgw_vip_preferred                   : 'vip_preferred',
		apmgw_vip_preferred_sdk               : 'vip_preferred',
		apmgw_pix							  : 'pix',
		apmgw_pix_banktransfer				  : 'pix',
		apmgw_pixviaopenfinance  			  : 'pix_open_finance',
		apmgw_pix_payouts					  : 'pix',
		apmgw_poli                            : 'poli',
		apmgw_polinz                          : 'poli',
		apmgw_postepay                        : 'postepay',
		apmgw_przelewy                        : 'przelewy24',
		apmgw_p24                             : 'przelewy24',
		apmgw_prompt_pay                      : 'prompt_pay',
		apmgw_przelew_bankowy                 : 'przelew_bankowy',
		apmgw_pugglepay                       : 'zimpler',
		apmgw_puntoxpress					  : 'punto_xpress',
		apmgw_puntored                        : 'puntored',
		apmgw_qr_redeban                      : 'redeban',
		apmgw_zimpler_se                      : 'zimpler',
		apmgw_zimpler_fi                      : 'zimpler',
		apmgw_zimpler_de                      : 'zimpler',
		apmgw_zip                      		  : 'zip',
		apmgw_qiwi                            : 'qiwi',
		apmgw_raberil                         : 'raberil',
		apmgw_rabbitlinepay                   : 'rabbit_line_pay',
		apmgw_rakuten_pay                     : 'rakuten_pay',
		apmgw_riverty                         : 'afterpay_riverty',
		apmgw_rupay                           : 'ru_pay',
		apmgw_safetypay                       : 'safetypay',
		apmgw_safetypay_cash                  : {default: 'es_safetypay_cash', 'en': 'en_safetypay_cash', 'pt': 'pt_safetypay_cash'},
		apmgw_safetypay_online                : {default: 'es_safetypay_online', 'en': 'en_safetypay_online', 'pt': 'pt_safetypay_online'},
		apmgw_safetypaypro                    : 'safetypay',
		apmgw_samsung_pay                     : 'samsung_pay',
		apmgw_scb_easy_pay					  : 'scb_bank',
		apmgw_scb_bank_mobile                 : 'scb_bank',
		apmgw_scb_atm                         : 'scb_bank',
		apmgw_secure_bank_transfer            : 'secure_bank_transfer',
		apmgw_sencillito                      : 'sencillito',
		apmgw_sepa                            : 'sepa',
		apmgw_sepa_payouts                    : 'sepa',
		ppp_sepamanualwd                      : 'sepa',
		apmgw_shopee_pay                      : 'shopee_pay_qris',
		apmgw_shopee_pay_wallet               : 'shopee_pay_qris',
		apmgw_sms_pin                         : 'smspin',
		sms                                   : 'smspin',
		apmgw_sms_ivr                         : 'smsivr',
		ivrmobile                             : 'smsivr',
		ivr                                   : 'smsivr',
		apmgw_south_korea_localcards          : 'default_cc_new',
		apmgw_sporopay                        : 'sporopay',
		apmgw_sugarpay                        : 'prompt_pay',
		apmgw_ssg_pay                         : 'ssgpay',
		apmgw_stpmex                          : 'stpmex_spei',
		apmgw_mx_payouts                      : 'stpmex_spei',
		apmgw_supersonic_ads                  : 'supersonicads',
		apmgw_swiff                           : 'swiff',
		apmgw_tabby                           : 'tabby',
		apmgw_teb_atm                         : 'teb',
		apmgw_teleingreso                     : 'teleingreso',
		apmgw_tiger_wallet                    : 'tigerpay',
		apmgw_tigo                            : 'tigo_pesa',
		apmgw_ticketsurf                      : 'ticketsurf',
		apmgw_tingg_wallet                    : 'tingg',
		apmgw_todito_cash                     : 'toditocash',
		apmgw_todito_cash_direct_integration_ : 'toditocash',
		apmgw_touchngo                        : 'touch_n_go',
		apmgw_toss                            : 'toss_payments',
		apmgw_transferencia_bancaria          : 'transferencia_bancaria',
		apmgw_truemoney                       : 'truemoney_wallet',
		apmgw_trustly                         : 'trustly',
		apmgw_trustly_di                      : 'trustly',
		apmgw_trustly_deposit                 : 'trustly',
		apmgw_trustpay                        : 'trustpay',
		apmgw_twint							  : 'twint',
		apmgw_tinaba						  : 'tinaba',
		apmgw_ukash                           : 'ukash',
		apmgw_unionpay                        : 'unionpay',
		apmgw_univoucher                      : 'univoucher',
		apmgw_upibyastropay                   : 'upi',
		apmgw_usemybank                       : 'usemyservices',
		apmgw_venmo                           : 'venmo',
		apmgw_venmopp                         : 'venmo',
		apmgw_verified_faster_payments        : 'faster_payments',
		apmgw_verified_sepa_payouts           : 'sepa',
		apmgw_visabyastropay                  : 'visa_by_astropay',
		apmgw_visa_vouchers                   : 'visa_vouchers',
		apmgw_vtcpay                          : 'vtcpay',
		apmgw_vtcpay_bank                     : 'vtcpay_banks',
		apmgw_vtcpay_cards                    : 'vtcpay_cards',
		apmgw_vtcpay_wallet                   : 'vtcpay_wallet',
		apmgw_wero                            : 'wero',
		apmgw_skrill_one_tap                  : 'skrill1tap',
		apmgw_zalopay                         : 'zalopay',
		ppp_wiretransfer                      : 'bank_transfer',          //'wiretransfercaliente',
		apmgw_sofort                          : 'sofort',
		ppp_westernunion                      : 'wu',
		apmgw_papercheque                     : 'cheque',
		apmgw_paperchequeexpress              : 'cheque',
		ppp_cheque                            : 'cheque',
		ppp_paddypower_shop                   : 'pp_shops_desktop',       // 'pp_shops_mobile'
		ppp_bpay                              : 'bpay',
		ppp_androidpay                        : 'android_pay',
		ppp_googlepay                         : 'google_pay',
		ppp_applepay                          : 'applepay',
		ppp_banktransfer                      : 'bank_transfer',
		ppp_manualwithdrawal                  : 'bank_transfer',
		bank_transfers                        : 'bank_transfer',
		apmgw_2c2p_payoutservice              : 'bank_transfer',
		apmgw_apac_bank_transfer              : 'bank_transfer',
		ppp_osko                              : 'osko',
		apmgw_banklink_u_net_                 : 'seb',
		apmgw_banklink__u_net_                : 'seb',
		apmgw_bank_pocztowy					  : 'bank_pocztowy',
		apmgw_klarna                          : 'klarna',
		apmgw_klarnacheckout                  : 'klarna',
		apmgw_klarnapayin14days               : 'klarna_invoice',
		apmgw_klarnapayin3months              : 'klarna_invoice',
        apmgw_klarnapayments24months          : 'klarna_part_payments',
        apmgw_klarna_pay_now                  : 'klarna_pay_now',
        apmgw_klarna_pay_later                : 'klarna_invoice',
        apmgw_klarna_slice_it                 : 'klarna_part_payments',
		apmgw_easyeft                         : 'easyeft',
		ppp_easyeftpayouts                    : 'easyeft',
		ppp_bacswithdraw                      : 'bacs',
		apmgw_pingit                          : 'pingit',
		vias                                  : 'adyen',
		adyen                                 : 'adyen',
		apmgw_wechat                          : 'wechat',
		apmgw_wechat_staticqr				  : 'wechat',
		apmgw_entercash                       : 'entercash',
		apmgw_ticket_premium                  : 'ticket_premium',
		apmgw_webanq                          : 'webanq',
		apmgw_2c2p_bay_atm                    : "bay",
		apmgw_2c2p_bay_bankcounter            : "bay",
		apmgw_2c2p_bay_ibanking               : "bay",
		apmgw_2c2p_bay_webpay                 : "bay",
		apmgw_2c2p_bbl_atm                    : "bbl",
		apmgw_2c2p_bbl_bankcounter            : "bbl",
		apmgw_2c2p_bbl_ibanking               : "bbl",
		apmgw_2c2p_ktb_atm                    : "ktb",
		apmgw_2c2p_ktb_bankcounter            : "ktb",
		apmgw_2c2p_ktb_ibanking               : "ktb",
		apmgw_2c2p_ktb_webpay                 : "ktb",
		apmgw_2c2p_scb_atm                    : "scb",
		apmgw_2c2p_scb_bankcounter            : "scb",
		apmgw_2c2p_scb_ibanking               : "scb",
		apmgw_2c2p_scb_webpay                 : "scb",
		apmgw_2c2p_tmb_atm                    : "tmb",
		apmgw_2c2p_tmb_bankcounter            : "tmb",
		apmgw_2c2p_tmb_ibanking               : "tmb",
		apmgw_2c2p_tmb_webpay                 : "tmb",
		apmgw_2c2p_uob_atm                    : "uob",
		apmgw_2c2p_uob_bankcounter            : "uob",
		apmgw_2c2p_uob_ibanking               : "uob",
		apmgw_2c2p_uob_webpay                 : "uob",
		apmgw_2c2p_tbank_atm                  : "tbank",
		apmgw_2c2p_tbank_bankcounter          : "tbank",
		apmgw_2c2p_tbank_ibanking             : "tbank",
		apmgw_2c2p_kbank_bankcounter          : "kbank",
		apmgw_2c2p_kbank_ibanking             : "kbank",
		apmgw_2c2p_bicg_overthecounter        : "bigc",
		apmgw_2c2p_mpay_overthecounter        : "mpay_station",           // "mpay",
		apmgw_2c2p_payatpost_overthecounter   : "payatpost",
		apmgw_2c2p_tesco_overthecounter       : "tesco_lotus",
		apmgw_2c2p_truemoney_overthecounter   : "truemoney",
		apmgw_2c2p_mol_7eleven_overthecounter : "cenpay",
		apmgw_2c2p_axs_kiosk                  : "axs",
		apmgw_2c2p_enets_citibanksgltd_webpay : "enets_citibanksgltd",
		apmgw_2c2p_enets_dbsbankltd_webpay    : "enets_dbsbankltd",
		apmgw_2c2p_enets_ocbcbankplus_webpay  : "enets_ocbcbankplus",
		apmgw_2c2p_enets_scbsgltd_webpay      : "enets_scbsgltd",
		apmgw_2c2p_enets_webpay               : "enets_uob",
		apmgw_2c2p_mol_affinbank_webpay       : "sam_over_the_counter",
		apmgw_2c2p_mol_amonline_webpay        : "sam_kiosk",
		apmgw_2c2p_indomaret_overthecounter   : "indomaret",
		apmgw_2c2p_biiva_atm                  : "biiva",
		apmgw_2c2p_biiva_ibanking             : "biiva",
		apmgw_2c2p_bank_mandiri_atm           : "bank_mandiri",
		apmgw_2c2p_mol_bankislam_webpay       : "24-Alfamart",
		apmgw_2c2p_bank_bca_atm               : "bank_bca",
		apmgw_2c2p_mol_esapay_overthecounter  : "bank_bca",
		apmgw_2c2p_mol_fpxhongleong_webpay    : "cimbva",
		apmgw_2c2p_mol_fpxrhbnow_webpay       : "cimbva",
		apmgw_2c2p_mol_maybank2e_webpay       : "danamon",
		apmgw_2c2p_mol_maybank2u_webpay       : "danamon",
		apmgw_2c2p_mol_pbe_webpay             : "bni",
		apmgw_2c2p_mol_pointbcard_webpay      : "bni",
		apmgw_2c2p_mol_ambank_webpay          : "revpay_amb",
		apmgw_2c2p_mol_cimbclicks_webpay      : "revpay_cimb",
		apmgw_2c2p_mol_fpxcimbclicks_webpay   : "revpay_fpx",
		apmgw_2c2p_mol_hongleong_webpay       : "revpay_hlb",
		apmgw_2c2p_mol_maybank_webpay         : "revpay_m2u",
		apmgw_2c2p_mol_rhbnow_webpay          : "revpay_rhb",
		apmgw_2c2p_mol_webcash_webpay         : "revpay_bkrm",
		apmgw_2c2p_revpay_bsn_webpay          : "revpay_bsn",
		apmgw_2c2p_revpay_mmb_webpay          : "revpay_mmb",
		apmgw_2c2p_revpay_pbb_webpay          : "revpay_pbb",
		apmgw_2c2p_dp_bayad_webpay            : "bayad",
		apmgw_2c2p_apms                       : "123s",
		apmgw_2c2p_epay_overthecounter		  : "epay_overthecounter",
		apmgw_e_pro                           : 'epro',
		apmgw_itau                            : 'itau',
		apmgw_banco_do_brasil                 : 'bancodebr',
		apmgw_bradesco                        : 'bradesco',
		apmgw_santander                       : 'santander',
		apmgw_oxigen_wallet					  : 'oxigen_wallet',
		apmgw_oxxo                            : 'oxxo',
		apmgw_oxxo_pay                        : 'oxxo', // 'oxxo_pay',
		apmgw_openbuckscard                   : 'obucks',
		apmgw_rapipago                        : 'rapipago',
		apmgw_pagofacil                       : 'pagofacil',
		apmgw_webpay                          : 'webpay',
		apmgw_pse                             : 'pse',
		apmgw_pse_pz                          : 'pse',
		apmgw_pse_wplay                       : 'pse_wplay',
		visa_checkout                         : 'visa_checkout',
		apmgw_snaicard                        : 'snaicard',
		apmgw_paymat                          : 'paymat',
		apmgw_fonix                           : 'fonix',
		apmgw_e_pro_visa                      : 'epro_visa',
		apmgw_bancontact                      : 'bancontact',
		apmgw_bancontact_card                 : 'bancontact',
		apmgw_bancontact_di                   : 'bancontact',
		bancontact_cc_card                    : 'bancontact',
		apmgw_siirto                          : 'siirto',
		apmgw_mybank                          : 'mybank',
		apmgw_swish                           : 'swish',
		apmgw_entercash_offline               : 'entercash_offline',
		ppp_instantwiretransfer               : 'wiretransfer',
		ppp_wt 								  : 'wiretransfer',
		ppp_wtdep 							  : 'wiretransfer',
		ppp_wt_salesforce                     : 'wiretransfer',
		apmgw_skrill_rapidtransfer            : 'rapidtransfer',
		apmgw_instant_open_banking            : 'open_banking',
		apmgw_interac                         : 'interac',
		apmgw_interac_combined                : 'interac_combined',
		apmgw_express_connect                 : 'express_connect',
		apmgw_interac_di                      : 'interac_instant',
		apmgw_interac_etransfer               : 'interac_e_transfer',
		apmgw_interac_instant                 : 'interac_instant',
		apmgw_ceska_sporitelna                : 'ceska_sporitelna',
		apmgw_komercni_banka_sk               : 'komercni_banka',
		apmgw_komercni_banka                  : 'komercni_banka',
		apmgw_unicredit                       : 'unicredit_bank',
		apmgw_raiffeisenbank                  : 'raiffeisenbank',
		apmgw_raiffeisenbank_sk               : 'raiffeisenbank',
		apmgw_fio_banka                       : 'fio_banka',
		apmgw_fio_banka_sk                    : 'fio_banka',
		apmgw_mbank                           : 'mbank',
		apmgw_mbank_sk                        : 'mbank',
		apmgw_moneta_money_bank               : 'moneta_money_bank',
		apmgw_sberbank                        : 'sberbank',
		apmgw_csob					  		  : 'csob',
		apmgw_csob_bank                       : 'csob',
		apmgw_era                             : 'era',
		apmgw_ecny                            : 'ecny',
		apmgw_onshop                          : 'onshop',
		apmgw_echeck                    	  :	'echeck',
		apmgw_echeckselect                    : 'echeckselect',
		apmgw_echeckselect_dob                : 'echeckselect',
		apmgw_mazoomaobt                      : 'online_banking',
		apmgw_online_banking                  : 'pwmb_online_banking',
		apmgw_airtel_money					  : 'airtel_money',
		apmgw_cash_card						  : 'cash_card',
		apmgw_freecharge					  : 'freecharge',
		apmgw_icash_card					  : 'icash_card',
		apmgw_itzcash						  : 'itzcash',
		apmgw_jiomoney						  : 'jiomoney',
		apmgw_netbanking					  : 'net_banking_new',
		apmgw_netbanking_tw					  : 'net_banking_new',
		apmgw_ola_money						  : 'ola_money',
		apmgw_pay_zapp						  : 'pay_zapp',
		apmgw_paycash_card					  : 'paycash_card',
		apmgw_paytm						      : 'paytm',
		apmgw_phonepe						  : 'phonepe',
		apmgw_prima_banka 					  : 'prima_banka',
		apmgw_upi						      : 'upi',
		apmgw_yesw						  	  : 'yesw',
		apmgw_ypay_cash						  : 'ypay_cash',
		apmgw_zipcash_card					  : 'zipcash_card',
		ppp_offlinebanks                      : 'offlinebanks',
		ppp_bankceskanarodni                  : 'offlinebanks',
		ppp_bankmufg                          : 'offlinebanks',
		ppp_bankceskoslovenskeuvernidruzstvo  : 'offlinebanks',
		ppp_bankcitfin                        : 'offlinebanks',
		ppp_bankmoravskypenezniustav          : 'offlinebanks',
		ppp_bankhypotecni                     : 'offlinebanks',
		ppp_bankpeneznidum                    : 'offlinebanks',
		ppp_bankartesa                        : 'offlinebanks',
		ppp_bankpostova                       : 'offlinebanks',
		ppp_bankcreditas                      : 'offlinebanks',
		ppp_bankney                           : 'offlinebanks',
		ppp_bankpodnikatelskadruzstevnizalozna: 'offlinebanks',
		ppp_bankcitibankeurope                : 'offlinebanks',
		ppp_bankairbank                       : 'offlinebanks',
		ppp_bankbnpparibaspf                  : 'offlinebanks',
		ppp_bankpko                           : 'offlinebanks',
		ppp_banking                           : 'offlinebanks',
		ppp_bankexpobank                      : 'offlinebanks',
		ppp_bankrozvojova                     : 'offlinebanks',
		ppp_bankjtbanka                       : 'offlinebanks',
		ppp_bankppf                           : 'offlinebanks',
		ppp_bankequa                          : 'offlinebanks',
		ppp_bankcommerz                       : 'offlinebanks',
		ppp_bankbnpparibassa                  : 'offlinebanks',
		ppp_bankvseobecnauverova              : 'offlinebanks',
		ppp_bankdeutschebank                  : 'offlinebanks',
		ppp_bankwaldviertlersparkassebank     : 'offlinebanks',
		ppp_bankraiffeisen                    : 'offlinebanks',
		ppp_bankceskomoravska                 : 'offlinebanks',
		ppp_bankwustenrot                     : 'offlinebanks',
		ppp_bankwustenrothypotecnibanka       : 'offlinebanks',
		ppp_bankmodrapyramida                 : 'offlinebanks',
		ppp_bankvolksbankrbb                  : 'offlinebanks',
		ppp_bankoberbank                      : 'offlinebanks',
		ppp_bankstavebnisporitelna            : 'offlinebanks',
		ppp_bankceskaexportni                 : 'offlinebanks',
		ppp_bankhsbc                          : 'offlinebanks',
		ppp_bankprivatbankrbb                 : 'offlinebanks',
		ppp_bankalternativepaymentsolutions   : 'offlinebanks',
		ppp_bankpaymentexecution              : 'offlinebanks',
		ppp_bankorangetrust                   : 'offlinebanks',
		ppp_bankeepays                        : 'offlinebanks',
		ppp_bankdruzstevnizaloznakredit       : 'offlinebanks',
		ppp_bankofchina                       : 'offlinebanks',
		ppp_bankpaymaster                     : 'offlinebanks',
		ppp_bankicbankofchina                 : 'offlinebanks',
		ppp_bankbefekt                        : 'offlinebanks',
		ppp_bankeuropay                       : 'offlinebanks',
		ppp_bankbusinesscredit                : 'offlinebanks',
		ppp_bankmoneychange                   : 'offlinebanks',
		ppp_bankfairplaypay                   : 'offlinebanks',
		ppp_bankmercuriuspartners             : 'offlinebanks',
		ppp_bankgrispayunion                  : 'offlinebanks',
		ppp_banknovared		                  : 'offlinebanks',
		ppp_bankpaysyseu                      : 'offlinebanks',
		ppp_bankeupsprovider                  : 'offlinebanks',
		ppp_bankandrastecapital               : 'offlinebanks',
		ppp_trinitybank						  : 'offlinebanks',
		ppp_sparkassebank					  : 'offlinebanks',
		ppp_fasbank					  		  : 'offlinebanks',
		ppp_moneypolobank					  : 'offlinebanks',
		ppp_bankofcommunications			  : 'offlinebanks',
		ppp_beekashbank			  			  : 'offlinebanks',
		ppp_qpaybank			  			  : 'offlinebanks',
		ppp_sberbank						  : 'offlinebanks',	
		ppp_shopwithdraw                      : 'shop-wdr',
		ppp_casashopwd                        : 'shop-wdr',
		ppp_ftnroshopwd                       : 'shop-wdr',
        apmgw_blik                            : 'blik',
		apmgw_blik_redirect                   : 'blik',
        apmgw_mbank_pl                        : 'mbank',
        apmgw_bzwbk                           : 'bzwbk',
        apmgw_pekao                           : 'pekao',
        apmgw_inteligo                        : 'inteligo',
        apmgw_ipko                            : 'ipko',
        apmgw_ing                             : 'ing',
        apmgw_getin                           : 'velo_bank',
        apmgw_noble                           : 'noble',
        apmgw_ideabank                        : 'ideabank',
        apmgw_credit_agricole                 : 'credit_agricole',
        apmgw_t_mobile                        : 't_mobile',
        apmgw_eurobank                        : 'eurobank',
        apmgw_alior_bank                      : 'alior_bank',
        apmgw_bank_millennium                 : 'bank_millennium',
        apmgw_deutsche_bank                   : 'deutsche_bank',
        apmgw_bos_bank                        : 'bos_bank',
        apmgw_bnp                             : 'bnp',
        apmgw_orange                          : 'orange',
        apmgw_banki_sp_ldzielcze              : 'banki_sp_ldzielcze',
        apmgw_vseobecna_uverova_banka		  : 'vseobecna_uverova_banka',
        apmgw_tatra_banka					  : 'tatra_banka',
        apmgw_unicredit_bank_sk				  : 'unicredit_bank',
        apmgw_slovenska_sporitelna			  : 'slovenska_sporitelna',
        apmgw_otp_banka	                      : 'otp_banka',
        apmgw_postova_banka					  : 'postova_banka',
        apmgw_csob_sk						  : 'csob',
		apmgw_sberbank_slovensko			  : 'sberbank',
		apmgw_passngo						  : 'passngo',
		apmgw_kwickgo						  : 'kwickgo',
		apmgw_tpay 							  : 'tpay',
		apmgw_muchbetter 					  : 'muchbetter',
		ppp_retail3rdpartydep				  : 'efectivo',
		ppp_defaultbtviasc					  : 'offlinebanks',
		apmgw_online_bank_transfer            : 'open_banking',
		apmgw_open_banking                    : 'open_banking',
        apmgw_cashlib_						  : 'cashlib',
        ppp_banktransferpl					  : 'ftn_offlinebank',
        ppp_banktransfersk					  : 'ftn_offlinebank',
		apmgw_mbway						      : 'mbway',
		apmgw_playtech_prepaidcard			  : 'playtech_prepaidcard',
		ppp_electronicbanktransf			  : 'electronic_bank_transfer',
		ppp_in_casino			              : 'in_casino',
		ppp_mvp								  : 'mvp',
		ppp_ohmycash			              : 'ohmycash',
        apmgw_postfinance_efinance            : 'postfinance_efinance',
        apmgw_postfinance_card				  : 'postfinance_card',
		apmgw_postfinance_pay 	   	  		  : 'pf_pay',
		apmgw_paysafecash					  : 'paysafecash',
		apmgw_payretailers					  : 'astropay-tef',
		apmgw_payretailers_payouts			  : 'astropaypayouts',
		apmgw_cobro_express					  : 'cobro_express',
		apmgw_multicaja						  : 'multicaja',
		apmgw_redcompra						  : 'redcompra',
		apmgw_bank_referenced				  : 'bank_referenced',
		apmgw_su_red__others_cash_			  : 'su_red_others_cash',
		apmgw_others_cash_mx				  : 'others_cash_mx',
		apmgw_seven_eleven					  : 'seven_eleven',
		apmgw_bcp							  : 'bcp',
		ppp_manualwt						  : 'ftn_offlinebank',
		ppp_wdtobank						  : 'ftn_offlinebank',
		ppp_pskpayslip						  : 'pskpayslip',
		ppp_pskdepositatshop				  : 'ftn_deposit_at_shop',
		ppp_pskshopwd						  : 'shop-wdr',
		apmgw_satispay                        : 'satispay',
		apmgw_bancomatpay                     : 'bancomatpay',
		apmgw_qris                            : 'qris',
		ppp_smspayments                       : 'ppp_smspayments',
		ppp_bankpartnersbanka				  : 'offlinebanks',
		ppp_ssbtdeposit						  : 'ssbt_deposit'
    };

	var existingRules = {
		ppp_applepay : true
	};

	function CssCreator() {
		this.pmhash = defaultPMMap;
		this.rules = [
			{
				classTpl      : _.template('.<%- className%>'),
				backgroundTpl : _.template('url( <%-imagePrefix%><%-imageName%>.svg) no-repeat center center ')
			},
			{
				classTpl      : _.template('.dr_pm_<%- className%>'),
				backgroundTpl : _.template('url( <%-imagePrefix%><%-imageName%>_wh.svg) no-repeat center center ')
			}
		];
		this.resourcePrefix = 'https://cdn.safecharge.com/pppthemes/pppv5/resources/img/svg/';
		//this.resourcePrefix = '/resources/img/svg/';
		this.isStatic = window.location.pathname.lastIndexOf('.html') > -1;
		// in case it is served by local node server in src/main
		if (this.isStatic) {
			this.resourcePrefix = '../../../webapp/resources/img/svg/';
		}
	}

	/**
	 *
	 * @param config - Customization object
	 * @param config.pmLogos - logo replacement
	 * @param config.rules - optional replaces default rules
	 * @param config.resourcePrefix - optional replaces default resource path
	 */
	CssCreator.prototype.setup = function (config) {
		config = config || {};
		config.language && (this.language = config.language);
		if (config.showAapplePayLogo) {
			existingRules.ppp_applepay = false
		}
		this.pmhash = $.extend(defaultPMMap, config.pmLogos);
		if (config.rules) {
			this.rules = _.map(config.rules, function (rule) {
				return {
					classTpl      : _.template(rule.classTpl),
					backgroundTpl : _.template(rule.backgroundTpl)
				};
			});
		}
		this.rules.push({
            classTpl      : _.template('.btrp_pmLogo.<%- className%>'),
            backgroundTpl : _.template('url( <%-imagePrefix%><%-imageName%>_wh.svg) no-repeat center center ')
        });
		if (_.has(config, 'resourcePrefix')) {
			this.resourcePrefix = config.resourcePrefix;
		}
	};
	/**
	 *
	 * @param className
	 * @returns {boolean} Result whether the rule is defined in the pm logo map
	 */
	CssCreator.prototype.makeRule = function (className) {
		if (existingRules[className]) {
			return true;
		}

		if (this.pmhash[className]) {
			var imageName = this.pmhash[className];
			if (_.isObject(imageName)) {
				if (this.language && imageName[this.language]) {
					imageName = imageName[this.language];
				} else {
					imageName = imageName["default"];
				}
			}
			var payload = {
				className   : className,
				imageName   : imageName,
				imagePrefix : this.resourcePrefix
			};
			_.forEach(this.rules, function (rule) {
				var cssObj = {};
				cssObj[rule.classTpl(payload)] = {
					background : rule.backgroundTpl(payload)
				};
				$.injectCSS(cssObj);
			});

			existingRules[className] = true;
		}
		return !!existingRules[className];
	};

	/**
	 *
	 * @param className {string}
	 * @param css_rules {object}
	 * @returns {boolean} Result whether the rule is defined
	 */
	CssCreator.prototype.addCustomRule = function (className, css_rules) {
		if (existingRules[className]) {
			return true;
		}
		if (css_rules) {
			var selectors = [];
			_.forEach(this.rules, function (rule) {
				selectors.push(rule.classTpl({className : className}));
			});
			var cssObj = {};
			cssObj[selectors.join(', ')] = css_rules;
			$.injectCSS(cssObj);
			existingRules[className] = true;
		}
		return !!existingRules[className];
	};
	return new CssCreator();
}());